import React, { useEffect, useState } from "react";
import { FindAttachments } from "./_requests";
import { AttachmentItem } from "./AttachmentItem";
import { toAbsoluteUrl } from "../../_helpers";
import SVG from "react-inlinesvg";
import { NewAttachmentButton } from "./NewAttachmentButton";
import { useSelector } from "react-redux";
import { HasCreateAccess, IsSuperUser} from "../../_helpers/AccessControlHelpers";
import {ATTACHMENT_MODEL} from "../../_helpers/AppModels";

export function AttachmentList({ model, recordId }) {
  const [attachments, setAttachments] = useState([]);

  const [loading, setLoading] = useState(true);

  const { user } = useSelector((state) => state.auth);

  const fetchData = () => {
    FindAttachments(model, recordId).then((result) => {
      setAttachments(result.data);
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className={"d-flex flex-wrap align-items-center"}>
      {loading && <p>Loading Files ....</p>}
      {attachments.map((attachment) => (
        <AttachmentItem
          user={user}
          onFileDelete={fetchData}
          key={attachment.id}
          attachmentName={attachment.fileName}
          attachmentId={attachment.id}
        />
      ))}

      {(HasCreateAccess(user, ATTACHMENT_MODEL) || IsSuperUser(user)) && (
        <NewAttachmentButton
          onNewFile={fetchData}
          model={model}
          recordId={recordId}
        />
      )}
    </div>
  );
}
